"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "greve-in-chianti": {
    "5bf7e1bc": [{
      "hkey": "672de351",
      "slug": "greve-in-chianti",
      "name": "Greve in Chianti",
      "primary": true,
      "skipSearch": false
    }],
    "castel-ruggero": [{
      "hkey": "672de351",
      "slug": "greve-in-chianti",
      "name": "Greve in Chianti",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c1686872": [{
      "hkey": "67360a2d",
      "slug": "la-panca",
      "name": "La Panca",
      "primary": true,
      "skipSearch": false
    }],
    "la-panca-dudda": [{
      "hkey": "67360a2d",
      "slug": "la-panca",
      "name": "La Panca",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "4f1c1ba2": [{
      "hkey": "672de351",
      "slug": "greve-in-chianti",
      "name": "Greve in Chianti",
      "primary": true,
      "skipSearch": false
    }],
    "mugnana": [{
      "hkey": "672de351",
      "slug": "greve-in-chianti",
      "name": "Greve in Chianti",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c8750885": [{
      "hkey": "6ffe56e0",
      "slug": "panzano-in-chianti",
      "name": "Panzano in Chianti",
      "primary": true,
      "skipSearch": false
    }],
    "panzano": [{
      "hkey": "6ffe56e0",
      "slug": "panzano-in-chianti",
      "name": "Panzano in Chianti",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "4bba21bc": [{
      "hkey": "672de351",
      "slug": "greve-in-chianti",
      "name": "Greve in Chianti",
      "primary": true,
      "skipSearch": false
    }],
    "uzzano": [{
      "hkey": "672de351",
      "slug": "greve-in-chianti",
      "name": "Greve in Chianti",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "1f18d380": [{
      "hkey": "672de351",
      "slug": "greve-in-chianti",
      "name": "Greve in Chianti",
      "primary": true,
      "skipSearch": false
    }],
    "verrazzano": [{
      "hkey": "672de351",
      "slug": "greve-in-chianti",
      "name": "Greve in Chianti",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;